import * as ko from 'knockout';
import type { IGameRecord } from '../../shared/interfaces/IGameRecord';

export class CfbGameRecord implements IGameRecord {
  Wins: KnockoutObservable<number>;
  Losses: KnockoutObservable<number>;
  Ties: KnockoutObservable<number>;
  RecordString: KnockoutComputed<string>;
  Differential: KnockoutComputed<number>;
  Pct: KnockoutComputed<number>;
  PctNaN: KnockoutComputed<number>;
  toString: KnockoutComputed<string>;

  constructor(fakeObs: KnockoutObservable<any>) {
    const self = this;
    self.Wins = ko.observable(0);
    self.Losses = ko.observable(0);
    self.Ties = ko.observable(0);

    self.RecordString = ko.computed(() => {
      let retStr = `${self.Wins()}-${self.Losses()}`;
      if (self.Ties() > 0) {
        retStr += `-${self.Ties()}`;
      }
      return retStr;
    });

    self.toString = ko.pureComputed(() => {
      let retStr = `${self.Wins()}-${self.Losses()}`;
      if (self.Ties() > 0) {
        retStr += `-${self.Ties()}`;
      }
      return retStr;
    });

    self.Differential = ko.pureComputed(() => self.Wins() - self.Losses());

    self.Pct = ko.pureComputed(() => {
      fakeObs();
      return self.calcWLT(self.Losses, self.Wins, self.Ties);
    });

    self.PctNaN = ko.pureComputed(() => {
      fakeObs();
      return self.calcPct(self.Losses, self.Wins, self.Ties);
    });
  }

  private calcWLT(
    losses: KnockoutObservable<number>,
    wins: KnockoutObservable<number>,
    ties: KnockoutObservable<number>,
  ): number {
    const denom = wins() + losses() + ties();
    if (denom === 0) return -1;
    return (wins() + 0.5 * ties()) / denom;
  }

  private calcPct(
    losses: KnockoutObservable<number>,
    wins: KnockoutObservable<number>,
    ties: KnockoutObservable<number>,
  ): number {
    const denom = wins() + losses() + ties();
    if (denom === 0) return -1;
    return (wins() + 0.5 * ties()) / denom;
  }

  resetWins() { this.Wins(0); }
  resetLosses() { this.Losses(0); }
  resetTies() { this.Ties(0); }
}
